/*
 * View for the topic categories area where categories can be added/modified/removed
 * from a topic
 */

define([
  "marionette",
  "jquery",
  "messaging/messenger",
  "modules/topicsSplit/topic/topicResponse/topicCategories/template/categories-template.html",
  "modules/topicsSplit/topic/topicResponse/topicCategories/template/category-value-template.html",
  "./topicCategoriesModel",
], function (Marionette, $, Messenger, CategoriesTemplate, CategoriesValueTemplate) {
  var TopicCategoriesView = {};

  TopicCategoriesView.categoryValuesView = Marionette.ItemView.extend({
    template: CategoriesValueTemplate,
    events: {
      "click #categoryDelete": "deleteItem",
    },
    deleteItem: function () {
      Messenger.vent.trigger("topic:category:list:delete:categoryValue", this.model);
    },
  });

  TopicCategoriesView.categoryView = Marionette.CompositeView.extend({
    template: CategoriesTemplate,
    itemView: TopicCategoriesView.categoryValuesView,
    itemViewContainer: "ul",
    initialize: function () {
      this.collection = this.model.getValues();
    },
  });

  TopicCategoriesView.accordionView = Marionette.CollectionView.extend({
    itemView: TopicCategoriesView.categoryView,
    scrollToCategory: function (categoryId) {
      $("#catList-" + categoryId)
        .scroll()
        .toggleClass("collapse");
    },
  });

  return TopicCategoriesView;
});
